import React from 'react';
import { TEXT2, TEXT3, BLUE, SUCCESS, WARNING, FONT } from '../../shared';

const VARIANT_STYLES = {
  primary: {
    background: 'rgba(14,165,233,0.10)',
    border: '1px solid rgba(14,165,233,0.30)',
    color: BLUE,
  },
  success: {
    background: `${SUCCESS}10`,
    border: `1px solid ${SUCCESS}35`,
    color: SUCCESS,
  },
  warning: {
    background: `${WARNING}10`,
    border: `1px solid ${WARNING}35`,
    color: WARNING,
  },
  ghost: {
    background: 'rgba(255,255,255,0.55)',
    border: '1px solid rgba(180,205,235,0.55)',
    color: TEXT2,
  },
};

// Built-in icons for common actions
const ACTION_ICONS = {
  post_now: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
    </svg>
  ),
  schedule: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  ),
  analytics_detail: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
    </svg>
  ),
  export: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
  ),
  edit: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
  ),
  regenerate: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
      <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/>
    </svg>
  ),
};

export default function ActionButtons({ buttons, onAction }) {
  if (!buttons?.length) return null;

  return (
    <div style={{
      display: 'flex',
      gap: 7,
      flexWrap: 'wrap',
      paddingTop: 4,
    }}>
      {buttons.map((btn, i) => {
        const variantStyle = VARIANT_STYLES[btn.variant] || VARIANT_STYLES.ghost;
        const icon = btn.icon ? ACTION_ICONS[btn.icon] : null;
        return (
          <button
            key={i}
            onClick={() => onAction?.({ type: 'action', action: btn.action, label: btn.label })}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 5,
              padding: '6px 13px',
              borderRadius: 8,
              fontSize: 12,
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: FONT,
              transition: 'all 0.18s',
              ...variantStyle,
            }}
            onMouseEnter={e => { e.currentTarget.style.opacity = '0.82'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'none'; }}
          >
            {icon && <span style={{ display: 'flex', alignItems: 'center' }}>{icon}</span>}
            {btn.label}
          </button>
        );
      })}
    </div>
  );
}
